export default function equal(self, other) {
  return self.commandName === other.commandName && self.paymentParametersId === other.paymentParametersId
}
